import { useMemo } from 'react';

import { TableColumnsService } from '@/components/pages/reports/services/TableColumnsService';

import useFetchReports from '@/utils/hooks/swr/reports/useFetchReports';
import useTranslation from '@/utils/hooks/translation/useTranslation';

import useToggle from '@/utils/hooks/utils/useToggle';

import DeleteAllVisibleReportsModal from '@/components/pages/reports/components/Modal/DeleteAllVisibleReportsModal';
import DeleteReportModal from '@/components/pages/reports/components/Modal/DeleteReportModal';
import TableList from '@/components/pages/reports/components/Table/TableList';
import TablePagination from '@/components/pages/reports/components/Table/TablePagination';
import TableWrapper from '@/components/pages/reports/components/Table/TableWrapper';
import TableFilters from '@/components/pages/reports/components/TableFilters';

const ScheduledReports = () => {
    const { t: tReports } = useTranslation('reports');
    const { isOpen, toggle, params, setParams } = useToggle();
    const { isOpen: isOpenDeleteAllVisible, toggle: toggleDeleteAllVisible } = useToggle();
    const { reports, mutateReports, requestParams, setRequestParams, errorReports, isLoading } =
        useFetchReports({
            isScheduled: true,
            params: { per_page: 5, page: 1 },
            options: {
                refreshInterval: 30000 // add refresh interval to get reports when they're ready
            }
        });

    const columnsScheduled = useMemo(
        () => TableColumnsService.getScheduledReportColumns(tReports, toggle, setParams),
        []
    );

    return (
        <div className="@container">
            <TableFilters requestParams={requestParams} setRequestParams={setRequestParams} />
            {reports?.data && reports?.data?.length ? (
                <div className="text-right">
                    <button
                        className="mb-2.5 text-xs text-icoBlue"
                        onClick={toggleDeleteAllVisible}>
                        {tReports('general.delete_all')}
                    </button>
                </div>
            ) : null}
            <TableWrapper>
                <TableList
                    data={reports?.data ?? []}
                    isLoading={isLoading}
                    errorReports={errorReports}
                    mutateReports={mutateReports}
                    requestParams={requestParams}
                    setRequestParams={setRequestParams}
                    columns={columnsScheduled}
                />
                <TablePagination
                    reports={reports}
                    isLoading={isLoading}
                    errorReports={errorReports}
                    requestParams={requestParams}
                    setRequestParams={setRequestParams}
                />
            </TableWrapper>
            <DeleteAllVisibleReportsModal
                isOpen={isOpenDeleteAllVisible}
                toggle={toggleDeleteAllVisible}
                reports={reports?.data ?? []}
                mutateReports={mutateReports}
            />
            <DeleteReportModal
                isOpen={isOpen}
                toggle={toggle}
                params={params}
                mutateReports={mutateReports}
            />
        </div>
    );
};

export default ScheduledReports;
